import React, { useEffect, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const LeaveDetail = () => {
  const navigate = useNavigate();
  const [modalData, setModalData] = useState<any>({});

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  const columns = [
    {
      title: "Apply Date",
      dataIndex: "application_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.application_date).valueOf() - dayjs(b.application_date).valueOf(),
    }
    ,
    {
      title: "Slice",
      dataIndex: "leave_slice_type",
      sorter: (a: any, b: any) => a.leave_slice_type - b.leave_slice_type,
    },
    {
      title: "From",
      dataIndex: "from_date",
      render: (text: string) =>
        text
          ? new Date(text).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
          : "------",
      sorter: (a: any, b: any) =>
        new Date(a.from_date).getTime() - new Date(b.from_date).getTime(),
    },

    {
      title: "To",
      dataIndex: "to_date",
      render: (text: string) =>
        text
          ? new Date(text).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
          : "------",
      sorter: (a: any, b: any) => {
        const aTime = a.to_date ? new Date(a.to_date).getTime() : 0;
        const bTime = b.to_date ? new Date(b.to_date).getTime() : 0;
        return aTime - bTime;
      },
    },

    {
      title: "Day",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days - b.Days,
    },

    {
      title: "Type",
      dataIndex: "leave_type",
      sorter: (a: any, b: any) => a.leave_type.localeCompare(b.leave_type),
    },
    {
      title: "Docs",
      dataIndex: "medical_certificate_file",
      render: (text: string) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary"
          >
            <i className="fa fa-eye"></i>
          </a>
        ) : (
          "-----"
        ),
      sorter: false,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={`badge ${text.toLowerCase().includes("approved")
            ? "bg-success"
            : text.toLowerCase().includes("rejected")
              ? "bg-danger"
              : "bg-warning"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: string, record: any) => {
        const isApproved =
          record.status === "APPROVED" || record.status === "REJECTED";
        return (
          <div className="action-icon d-inline-flex">
            <Link
              to="#"
              className="text-success"
              title="View"
              data-bs-toggle="modal"
              data-bs-target={`${record.status === "APPROVED"
                ? "#approve-modal"
                : record.status === "REJECTED"
                  ? "#rejected-modal"
                  : "#apply-modal"
                }`}
              onClick={() => {
                setModalData(record);
              }}
            >
              <i className="ti ti-eye" />
            </Link>
            <button
              className="btn btn-sm out-linetext-info"
              style={{
                cursor: isApproved ? "not-allowed" : "pointer",
              }}
              title="Edit"
              onClick={() => {
                if (!isApproved) handleEdit(record);
              }}
            >
              <i className="ti ti-edit" />
            </button>{" "}
            <Link
              to="#"
              className="text-danger"
              style={{
                cursor: isApproved ? "not-allowed" : "pointer",
              }}
              title="Delete"
              onClick={() => {
                if (!isApproved) deleteRequest(record?.leave_application_id);
              }}
            >
              <i className="ti ti-trash" />
            </Link>
          </div>
        );
      },
    },
  ];

  const handleEdit = (record: any) => {
    localStorage.setItem("editLeaveData", JSON.stringify(record));
    navigate("/edit-leave-application");
  };
  const {
    data: leave_details,
    loading: leave_details_loading,
    error: leave_Details_error,
    callApi: fetchLeaveDetails,
  } = useApi("/api/view-leave-status", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year]
  });

  const data = leave_details?.data.map((item: any, index: number) => {
    return {
      ...item,
      Days: item.days === null ? "------" : item.days,
    };
  });

  const {
    data: request_delete,
    loading: request_delete_loading,
    error: request_delete_error,
    callApi: deleteLeaveRequest,
  } = useApi("/api/delete-leave/:id", {
    method: "DELETE",
    autoCall: false,
  });

  const deleteRequest = async (request_id: any) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this leave request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (confirmResult.isConfirmed) {
      try {
        const response = await deleteLeaveRequest(
          undefined,
          `/api/delete-leave/${request_id}`
        );
        console.log(response);
        if (response.statusCode === 200) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text:
              response?.message ||
              "Leave request has been deleted successfully.",
            timer: 2000,
            showConfirmButton: true,
          });
          await fetchLeaveDetails();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Could not delete the leave request.",
          });
        }
      } catch (error) {
        console.error("Delete failed:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while deleting the leave request.",
        });
      }
    }
  };

  return (
    <>
      {/* <Loader loading={ } /> */}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leave Details</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Leave</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.seflGrid}>Self Leave</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leave Details
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div>
                <Link
                  to="/leave-application"
                  className="btn btn-primary custom_button py-1 px-3"
                >
                  Apply Leave
                </Link>
              </div>
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                  ))}
                </select>

              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body p-0">
              <Table dataSource={data} columns={columns} Selection={false} showSearchInput={true} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      {/* modal */}

      <div
        id="approve-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="approve-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="approve-modalLabel">
                Leave Application Approved
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Approved By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_by_name === null
                    ? modalData?.approved_by
                    : modalData?.approved_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Approved On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_on
                    ? dayjs(modalData.approved_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Rejected  */}
      <div
        id="rejected-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="rejected-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white">
              <h5 className="modal-title" id="rejected-modalLabel">
                Leave Application Rejected
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Rejected By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_by_name === null
                    ? modalData?.rejected_by
                    : modalData?.rejected_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejection Reason:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejection_reason || "N/A"}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejected On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_on
                    ? dayjs(modalData.rejected_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Apply */}

      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="apply-modalLabel">
                Leave Application Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>Leave Type:</strong>
                  <p className="text-muted">{modalData?.leave_type || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Leave Slice:</strong>
                  <p className="text-muted">
                    {modalData?.leave_slice_type || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>From Date:</strong>
                  <p className="text-muted">
                    {modalData?.from_date
                      ? new Date(modalData.from_date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                      : "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>To Date:</strong>
                  <p className="text-muted">
                    {modalData?.to_date
                      ? new Date(modalData.to_date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                      : "--"}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Number of Days:</strong>
                  <p className="text-muted">{modalData?.Days || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Application Date:</strong>
                  <p className="text-muted">
                    {modalData?.application_date
                      ? new Date(modalData.application_date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                      : "N/A"}
                  </p>
                </div>
                <div className="col-12 mb-3">
                  <strong>Reason:</strong>
                  <p className="text-muted">
                    {modalData?.application_reason || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Manager Email:</strong>
                  <p className="text-muted">
                    {modalData?.manager_email_id || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>CC Email:</strong>
                  <p className="text-muted">{modalData?.cc_email || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Medical Certificate:</strong>
                  <p className="text-muted">
                    {modalData?.medical_certificate_file ? (
                      <a
                        href={modalData?.medical_certificate_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary"
                      >
                        View File
                      </a>
                    ) : (
                      "Not Provided"
                    )}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Status:</strong>
                  <p>
                    <span
                      className={`badge ${modalData?.status === "APPROVED"
                        ? "bg-success"
                        : modalData?.status === "REJECTED"
                          ? "bg-danger"
                          : "bg-warning text-dark"
                        }`}
                    >
                      {modalData?.status || "PENDING"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary custom_button"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveDetail;
